/**
 * Priority Member: Anmeldung an eine Klaviyo Liste.
 *
 * Genutzt wird der Client Endpunkt von Klaviyo. Der braucht nur den
 * oeffentlichen Schluessel des Kontos, der ohnehin in jeder Seite steht, und
 * laeuft ohne serverseitigen Schluessel.
 *
 * Ob eine Bestaetigungsmail rausgeht, entscheidet die Liste in Klaviyo. Steht
 * sie auf Double Opt-in, verschickt Klaviyo die Mail selbst. Der Hinweistext in
 * der Section sagt genau das an, deshalb muss die Liste auch auf Double Opt-in
 * stehen, sonst verspricht die Seite etwas, das nicht passiert.
 */
(function () {
  var ENDPUNKT = 'https://a.klaviyo.com/client/subscriptions/';
  var REVISION = '2024-10-15';

  function meldungZeigen(feld, art, text) {
    if (!feld) return;
    var textFeld = feld.querySelector('[data-meldung-text]');
    feld.hidden = false;
    if (textFeld) {
      textFeld.textContent = text;
    } else {
      feld.textContent = text;
    }
    feld.classList.remove('priority-member__meldung--erfolg', 'priority-member__meldung--fehler');
    feld.classList.add('priority-member__meldung--' + art);
  }

  function anmelden(form) {
    var eingabe = form.querySelector('.priority-member__feld');
    var knopf = form.querySelector('.priority-member__knopf');
    var meldung = form.querySelector('[data-meldung]');
    var pille = form.querySelector('.priority-member__pille');
    var companyId = form.dataset.companyId;
    var listId = form.dataset.listId;
    var adresse = (eingabe.value || '').trim();

    if (!adresse || !eingabe.checkValidity()) {
      meldungZeigen(meldung, 'fehler', meldung.dataset.textUngueltig);
      eingabe.focus();
      return;
    }

    if (!companyId || !listId) {
      // Ohne Konto oder Liste kann nichts ankommen. Lieber ehrlich melden,
      // als eine Anmeldung vorzutaeuschen.
      meldungZeigen(meldung, 'fehler', meldung.dataset.textFehler);
      return;
    }

    form.classList.add('priority-member__form--laeuft');
    knopf.disabled = true;

    fetch(ENDPUNKT + '?company_id=' + encodeURIComponent(companyId), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        revision: REVISION,
      },
      body: JSON.stringify({
        data: {
          type: 'subscription',
          attributes: {
            profile: {
              data: {
                type: 'profile',
                attributes: { email: adresse },
              },
            },
          },
          relationships: {
            list: { data: { type: 'list', id: listId } },
          },
        },
      }),
    })
      .then(function (antwort) {
        form.classList.remove('priority-member__form--laeuft');
        knopf.disabled = false;
        if (antwort.ok || antwort.status === 202) {
          // Geschafft. Das Eingabefeld verschwindet, damit die Bestaetigung
          // die einzige Aussage in der Flaeche ist.
          if (pille) pille.hidden = true;
          var hinweis = form.querySelector('.priority-member__hinweis');
          if (hinweis) hinweis.hidden = true;
          meldungZeigen(meldung, 'erfolg', meldung.dataset.textErfolg);
          return;
        }
        meldungZeigen(meldung, 'fehler', meldung.dataset.textFehler);
      })
      .catch(function () {
        form.classList.remove('priority-member__form--laeuft');
        knopf.disabled = false;
        meldungZeigen(meldung, 'fehler', meldung.dataset.textFehler);
      });
  }

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || !form.matches('[data-priority-member]')) return;
    event.preventDefault();
    anmelden(form);
  });
})();
